<div>
  <section class="form-tasklist">
    <mat-card>
      <mat-card-title>
        Accept Terms
      </mat-card-title>

      <div style="margin-top:21px;">


        <form [formGroup]="formPermissions" autocomplete="off">
          <ng-container formArrayName="terms">
            @for (term of listterms; track term; let i = $index) {
              <div class="term-line" style=" display: flex; align-items: flex-start;margin: 12px 0;"
                >
                <mat-checkbox style=" margin-right: 12px;" [formControlName]="i">
                </mat-checkbox>
                <div class="term-text">
                  <div class="term-html" [attr.data-id]="term.id" [innerHTML]="getTermHtml(term, i)"
                    (click)="onTermHtmlClick($event)">
                  </div>
                </div>
              </div>
            }
          </ng-container>
        </form>
        <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px;">
          <button mat-raised-button color="accent"
            [disabled]="formPermissions?.invalid"
            (click)="onClickYes()">
            YES
          </button>

          <div style="flex: 1; text-align: left; min-width: 200px;">
            {{ termsdescription }}
          </div>
        </div>

      </div>